export function getIsCrmObject(object) {
  return object.objectId !== undefined;
}